import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  class: "stroke-current",
  "data-slot": "icon",
  viewBox: "0 0 16 16",
  fill: "none",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.75 8H13.25M2.75 8L5.25 5.5M2.75 8L5.25 10.5",
    "stroke-width": "{1.5}",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)

import VButton from '@/components/Buttons/VButton.vue'

	import { 
		clsx
	} from 'clsx'

	
	const __default__ = { name: 'VPaginationPrevious' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		className: {
			type: String,
			default: ''
		},
		children: {
			type: String,
			default: "Previous"
		},
		href: {
			type: String,
			default: null
		}
	},
  setup(__props) {

	const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(_unref(clsx)(__props.className, 'grow basis-0'))
  }, [
    _createVNode(VButton, {
      href: __props.href ? __props.href : undefined,
      disabled: __props.href === null ? true : false,
      plain: "",
      "aria-label": "Previous page"
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createTextVNode(" " + _toDisplayString(__props.children), 1)
      ]),
      _: 1
    }, 8, ["href", "disabled"])
  ], 2))
}
}

})